import gql from 'graphql-tag'

const getCentersForMobile = schema => gql`query getCentersForMobile {
    ${schema}_donation_center__c {
        id,
        address_line1__c,
        address_line2__c,
        telephone__c,
        sfid,
        city__c,
        state__c,
        name,
        latitude__c,
        longitude__c,
        state_code__c,
        zipcode__c,
        spanish_supported__c,
        center_num__c,
        is_center_hidden_from_donors__c
    }
  }`

export default getCentersForMobile
